<template>
  <ul class="select-title ljb-flex-row">
    <li
      v-for="(item,key) in selectBar.selectList"
      :key="key"
      :class="{active:selectBar.index == key}"
      class="item ljb-flex-column ljb-double-center"
      @click="selectType(item,key)">{{ item.typeName }}
      <div
        :class="{active:selectBar.index == key}"
        class="line"/>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'SelectBar',
  props: {
    selectBar: {
      type: Object,
      default: function () {
        return ''
      }
    }
  },
  methods: {
    selectType (item, key) {
      this.selectBar.index = key
      this.$emit('selectType', item)
    }
  }
}
</script>

<style lang="scss" scoped>
  .select-title {
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    text-align: center;
    position: fixed;
    top:0;
    z-index: 1;
  }
  .item {
    flex:1;
    line-height: 37px;
    font-size: 15px;
    color: #222;
    &.active {
      color: #C48500;
      font-weight: 600;
    }
  }
  .line{
    height: 3px;
    width: 55px;
    background-color: white;
    &.active {
      background-color: #C48500;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SelectBar.vue